import React from "react";

export function FictionalBadge({ className = "" }) {
  return (
    <span
      data-testid="fictional-ai-badge"
      className={`inline-flex items-center rounded-full border border-[#3D3428] bg-[#1A1714] px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-[#D4AF37] ${className}`}
    >
      AI persona
    </span>
  );
}

export function StagePill({ stage }) {
  return (
    <span className="inline-flex items-center rounded-full border border-[#3D3428] px-2 py-0.5 text-[10px] text-[#C8C2B5]">
      {stage}
    </span>
  );
}
